import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-impressum',
  standalone: true,
  imports: [],
  templateUrl: './impressum.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './impressum.component.scss'
})
export class ImpressumComponent {

}
